import { fetchQuery, graphql } from "relay-runtime"
import {
  betterDocCareProviderSearchQuery as betterDocCareProviderSearchQueryDescriptor,
  betterDocCareProviderSearchQuery$data,
  betterDocCareProviderSearchQuery$variables,
} from "@/modules/patients/detail/better-doc/de/services/__generated__/betterDocCareProviderSearchQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

export const betterDocCareProviderSearchQuery = graphql`
  query betterDocCareProviderSearchQuery(
    $progressNoteId: ID!
    $effectivePointOfCare: PointOfCareType!
    $specialtyId: ID
    $name: String
    $city: String
    $street: String
  ) {
    de_betterDocCareProviderSearch(
      progressNoteId: $progressNoteId
      effectivePointOfCare: $effectivePointOfCare
      specialtyId: $specialtyId
      name: $name
      city: $city
      street: $street
    ) {
      status
      careProviders {
        medhubActivityId
        medicMedhubId
        workplaceMedhubId
        medicName
        workplaceName
        street
        postalCode
        city
        countryCode
      }
    }
  }
`

export type BetterDocCareProviderSearchResult = betterDocCareProviderSearchQuery$data["de_betterDocCareProviderSearch"]

export type BetterDocCareProviderSearchItem = BetterDocCareProviderSearchResult["careProviders"][number]

export const fetchBetterDocCareProviderSearch = async (variables: betterDocCareProviderSearchQuery$variables) => {
  const response = await fetchQuery<betterDocCareProviderSearchQueryDescriptor>(
    RelayEnvironment,
    betterDocCareProviderSearchQuery,
    variables,
    { fetchPolicy: "network-only" },
  ).toPromise()
  return response?.de_betterDocCareProviderSearch
}
